import { TAB_MODULES, tabsModulesList } from 'components/Header/utils';
import { allModules, APP_MODULES, APPS } from 'constants/appModules';
import { EDDR_MODULES, eddrModules } from 'constants/eddrModules';
import { EDDR_MODULE_ROOT_PATHS, MODULE_ROOT_PATHS, PATHS } from 'constants/paths';
import { getLastActiveWellbore } from 'helpers/WellHelper';
import { ObjectKeys } from 'helpers/ts-helpers';
import { parse } from 'query-string';
import { WellFullDetailsWithUniqueKeyDTO } from 'types/well';
import { InnerWellboreWithWellInfo } from 'types/wellbore';

export const getAppFromPath = (path: string): APPS => {
  return APPS.DRILLX_SMART_OPERATIONS;
};

export const getModuleFromPath = (path: string): APP_MODULES => {
  if (path === MODULE_ROOT_PATHS.HOME) return APP_MODULES.HOME;

  return (
    allModules
      .filter(module => module !== APP_MODULES.HOME)
      .find(module => path.startsWith(MODULE_ROOT_PATHS[module])) ?? APP_MODULES.HOME
  );
};

export const getTabsModuleFromPath = (path: string): TAB_MODULES | undefined => {
  return tabsModulesList.find(module => path.startsWith(MODULE_ROOT_PATHS[module]));
};

export const getPageNameFromPath = (path: string): keyof typeof PATHS => {
  return ObjectKeys(PATHS).find(key => PATHS[key] === path) as keyof typeof PATHS;
};

export const getEddrModuleFromPath = (path: string): EDDR_MODULES | null => {
  for (const module of eddrModules) {
    const moduleRootPath = EDDR_MODULE_ROOT_PATHS[module as keyof typeof EDDR_MODULE_ROOT_PATHS];
    if (path.startsWith(`${MODULE_ROOT_PATHS.EDDR}${moduleRootPath}`)) {
      return module;
    }
  }

  return null;
};

export const getCurrentWellAndWellboreFromPath = (
  wells: WellFullDetailsWithUniqueKeyDTO[],
  wellbores: InnerWellboreWithWellInfo[],
  wellboreId: string | undefined,
  tuwi: string | undefined,
  tuwbi: string | undefined,
  queryParamsString: string,
  wellPlanId: string | undefined,
): { wellbore?: InnerWellboreWithWellInfo; well?: WellFullDetailsWithUniqueKeyDTO } => {
  const getLastSensorWellboreFromWell = (well?: WellFullDetailsWithUniqueKeyDTO) =>
    wellbores.find(wellbore => wellbore.wellboreId === getLastActiveWellbore(well)?.wellboreId);

  if (tuwi) {
    const currentWell = wells.find(well => well.tuwi === tuwi);

    return {
      well: currentWell,
      wellbore: getLastSensorWellboreFromWell(currentWell),
    };
  } else if (wellboreId) {
    return {
      well: wells.find(well =>
        well.wellbores?.some(wellbore => wellbore.wellboreId === wellboreId),
      ),
      wellbore: wellbores.find(wellbore => wellbore.wellboreId === wellboreId),
    };
  } else if (tuwbi) {
    return {
      well: wells.find(well => well.wellbores?.some(wellbore => wellbore.tuwbi === tuwbi)),
      wellbore: wellbores.find(wellbore => wellbore.tuwbi === tuwbi),
    };
  } else {
    // if current well not found from query params, try to get it from query string (ex: real time page - performance module)
    const queryParams = parse(queryParamsString, { arrayFormat: 'bracket' });
    const wellTuwisParams = queryParams.wellTuwis;
    if (wellTuwisParams?.length) {
      const currentWell = wells.find(well => well.tuwi === wellTuwisParams[0]);

      return {
        well: currentWell,
        wellbore: getLastSensorWellboreFromWell(currentWell),
      };
    }
  }

  return {};
};
